import React from "react";

import { capitalize, filter } from "lodash";

import Input from "../forms/Input";

export default class DataTableWInputHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayFilter: false,
      filterText: "",
      mappedHeaders: Object.keys(this.props.data[0]).map((d, i) => ({
        name: d,
        input_col_position: i + 1,
        map_to: null,
      })),
    };
  }

  toggleFilterInput = () => {
    this.setState({
      ...this.state,
      displayFilter: !this.state.displayFilter,
    });
  };

  handleFilterTextChange = (val) => {
    this.setState({
      ...this.state,
      filterText: val.trim().toLowerCase(),
    });
  };

  //when the filter text updates
  //update the dataset
  //dispatch to the store and filter the data there
  filterData = (data) => {
    const predicate = (o) => {
      //for object keys
      //if k[0] is underscore move in
      //ignore numbers
      let k = null;
      for (k in o) {
        const v = o[k];

        if (typeof v === "number") continue;

        const coercedValue = String(v);

        if (coercedValue.trim().toLowerCase().includes(this.state.filterText)) {
          return true;
        }
      }
      return false;
    };

    //check for the presence of this.state.filterText in various fields
    //go through unknown objects and check for presence in values
    let res;
    if (this.state.filterText === "") {
      res = data;
    } else {
      res = filter(data, predicate);
    }

    if (this.props.rowsToDisplay) return res.slice(0, this.props.rowsToDisplay);
    return res;
  };

  buildHeaders = () => {
    if (!this.props.data.length) return;
    if (!this.props.data.length) return;

    let keys = Object.keys(this.props.data[0]);

    let selectOptions = [
      { display: "Select", value: "" },
      ...this.props.selectableFields,
    ];

    return keys
      .filter((d) => d !== "id" && d !== "woxId")
      .filter((d) => d.charAt(0) !== "_")
      .map((d, i) => (
        <th key={d} className="compact-table">
          <div style={{ whiteSpace: "nowrap" }}>{d}</div>
          <Input
            options={selectOptions}
            data-testid={`test-id-header-${i}`}
            returndisplay="true"
            classNames="data-table-header-select"
            type="select"
            label={d}
            onChange={(v, display) => {
              let newMappedHeaders = this.state.mappedHeaders;

              if (v === "") {
                newMappedHeaders[i] = {
                  name: d,
                  input_col_position: i + 1,
                  map_to: null,
                };
              }

              newMappedHeaders[i] = {
                name: display,
                input_col_position: i + 1,
                map_to: v,
              };
              this.setState({ mappedHeaders: newMappedHeaders });
            }}
          />
        </th>
      ));
  };

  buildRows = () => {
    if (!this.props.data.length) return <tr></tr>;

    const displayData = this.filterData(this.props.data);

    return displayData.map((d, i) => {
      let keys = Object.keys(d);

      // the data that we are getting is always different, so
      // a row called woxId is added when the data is grabbed allowing us to
      // successfully key the itterated render
      // actual cells never change so they can be keyed on index
      let cells = keys
        .filter((v) => v !== "id" && v !== "woxId")
        .filter((v) => v.charAt(0) !== "_")
        .map((v, j) => (
          <td key={j} className="compact-table">
            {d[v]}
          </td>
        ));

      if (this.props.events_modal) {
        return <tr onClick={() => this.props.events_modal(d)}>{cells}</tr>;
      }
      return <tr key={d[this.props.rowKey]}>{cells}</tr>;
    });
  };

  // recursive functions allowing us to make sure that the required headers are met
  // this format allows for this or that requirements to be met
  // if passed  ['city_state_zip', ['city', 'state', 'zip5']]
  // either city_state_zip or city, state, zip5 must be present
  // grouped requirements must go to the right of single requirements
  // TODO: support group or group requirements
  checkMappedHeaders = (headers, requiredHeaders, arr = []) => {
    let foundPositiveString = false;
    let subArr = [];

    requiredHeaders.forEach((h) => {
      if (typeof h === "string") {
        if (!headers.find((d) => d?.map_to === h)) {
          subArr.push(h);
        } else {
          foundPositiveString = true;
        }
      } else {
        !foundPositiveString && this.checkMappedHeaders(headers, h, subArr);
      }
    });
    arr.push(subArr);
    return arr;
  };

  // [list of headers] -> [list of strings]
  // returns a list of all duplicate headers
  // the field map will fail if multiple headers are mapped to the same field
  // so we need to make sure that there are no duplicates
  checkDuplicates = (headers) => {
    let duplicates = new Set();
    headers.forEach((h) => {
      if (h?.map_to) {
        if (headers.find((d) => d?.map_to === h.map_to && d !== h)) {
          duplicates.add(h.map_to);
        }
      }
    });
    return Array.from(duplicates);
  };

  renderMissingHeaders = (difference) => {
    console.log(difference);
    this.setState({
      error: (
        <div className="danger-text">
          Missing required headers:
          <ul>
            {/* <ListItem item={difference} /> */}
            {difference.map((d) => {
              if (Array.isArray(d)) {
                if (!d.length) return false;
                const formatted = d.reduce((acc, cur) => {
                  if (Array.isArray(cur)) {
                    return (
                      acc +
                      "  (or " +
                      cur
                        .map((n) => capitalize(n.split("_").join(" ")))
                        .join(", ") +
                      ")"
                    );
                  }
                  return `${acc} ${acc.length ? ", " : ""} ${capitalize(
                    cur.split("_").join(" ")
                  )}`;
                }, "");
                return <li>{formatted}</li>;
              }
              return <li key={d}>{capitalize(d.split("_").join(" "))}</li>;
            })}
          </ul>
        </div>
      ),
    });
  };

  renderDuplicates = (duplicates) => {
    this.setState({
      error: (
        <div className="danger-text">
          Duplicate headers:
          <ul>
            {duplicates.map((d) => (
              <li key={d}>{capitalize(d.split("_").join(" "))}</li>
            ))}
          </ul>
        </div>
      ),
    });
  };

  handleUpload = () => {
    const { mappedHeaders } = this.state;
    const { requiredHeaders } = this.props;

    const difference = this.checkMappedHeaders(mappedHeaders, requiredHeaders);
    const has_difference = difference.flat(Infinity).length;
    has_difference
      ? this.renderMissingHeaders(...difference)
      : this.setState({ error: null });

    const duplicates = this.checkDuplicates(mappedHeaders);
    const has_duplicates = duplicates.length;
    has_duplicates && this.renderDuplicates(duplicates);
    if (!has_duplicates && !has_difference)
      this.props.handleUpload(this.state.mappedHeaders);
  };

  render() {
    return (
      <div>
        <div
          className="info-panel"
          style={{
            minWidth: "1200px",
          }}
        >
          <div className="info-panel-heading">
            {this.props.title}
            <i
              style={{ float: "right", marginTop: "7px" }}
              onClick={this.toggleFilterInput}
              className="fa fa-filter"
              aria-hidden="true"
            />
            <span
              style={{
                float: "right",
                margin: "0 15px 0 0",
                fontSize: "10px",
              }}
            >
              {this.filterData(this.props.data).length} of{" "}
              {this.props.data.length} rows
            </span>
          </div>
          {!this.state.displayFilter && !this.props.displayFilter ? null : (
            <Input
              type={"text"}
              default={this.state.filterText}
              onChange={this.handleFilterTextChange}
              placeholder={this.props.filterText || "Filter..."}
            />
          )}
          <div className="content">
            <table className="tbl-med">
              <thead>
                <tr>{this.buildHeaders()}</tr>
              </thead>
              <tbody>{this.buildRows()}</tbody>
            </table>
          </div>
        </div>
        <button
          className="btn btn-primary"
          onClick={this.handleUpload}
          href="#"
        >
          Upload
        </button>
        {this.state.error && <div>{this.state.error}</div>}
      </div>
    );
  }
}
